  import { computed } from "vue";
  import { useSheetController } from '@/composables/useSheetsController'

  export function useSheetContentComponent(type, components) {
    const componentName = computed(() => {
      const contentNamePartsArray = useSheetController.sheets[type].content.split('-')
      const contentCamelCaseName = contentNamePartsArray.map(part => `${part.charAt(0).toUpperCase()}${part.slice(1)}`).join('');

      return `SheetContent${contentCamelCaseName}`;
    });
    
    return components[componentName.value];
  }
